import api from './api';

export class CompanyService {
  static updateCompany = (id: string, data: any) => {
    return api.put(`/companies/${id}`, data);
  };

  static getAssociatedCompany = () => {
    return api.get<any>('/profile/associated-companies');
  };

  static changeCover = (image: string | Blob, id: string) => {
    const formData = new FormData();
    formData.append('file', image);
    formData.append('_method', 'PATCH');

    return api.patch(`/companies/files/company/${id}/cover`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  static getIndustries = () => {
    return api.get('/industries');
  };

  static changeAvatar = (data: any, id: string) => {
    return api.patch(`/companies/files/company/${id}/avatar`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
}
